<script lang="ts" setup>
  import { PlainTooltip } from "@/components/ui/plain-tooltip"

  import { StepNote } from "./StepperTypes"

  defineProps<{ note: StepNote }>()
</script>

<template>
  <div
    class="pointer-events-auto flex items-center gap-1 text-sm text-secondary-500"
    data-testid="stepper-note"
  >
    <span aria-hidden="true" class="sm:hidden">|</span>
    <span>{{ note.label }}</span>
    <PlainTooltip :trigger-label="`About ${note.label}`">
      {{ note.tooltip }}
    </PlainTooltip>
  </div>
</template>
